import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ContentChild,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { AbstractControl, FormGroupDirective } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';

import { PortalFieldConfig } from '@lockton-apps/shared/interfaces';

@Directive({
    selector: '[laFormPortalConfigField]',
    standalone: false
})
export class FormPortalConfigFieldDirective implements OnInit {
  @Input('laFormPortalConfigField') fieldKey!: string;

  control!: AbstractControl | null;

  hidden = false;

  @HostBinding('class.d-none') get hiddenClass() {
    return this.hidden;
  }

  @ContentChild(MatLabel, { read: ElementRef }) labelElement!: ElementRef;

  constructor(private formGroup: FormGroupDirective) {}

  ngOnInit(): void {
    this.control = this.formGroup.form.get(this.fieldKey);
  }

  applyConfig(config: PortalFieldConfig) {
    this.setLabel(config.label);
    this.setHidden(config.hidden);
    this.setDisabled(config.disabled);
    this.setDefaultValue(config.defaultValue);
  }

  private setLabel(value: string | undefined) {
    if (!this.labelElement || !value) {
      return;
    }
    this.labelElement.nativeElement.innerText = value;
  }

  private setHidden(value: BooleanInput = false) {
    this.hidden = coerceBooleanProperty(value);
  }

  private setDisabled(value: BooleanInput = false) {
    if (!this.control) {
      return;
    }

    if (this.control.enabled && value) {
      this.control.disable();
    }
    if (this.control.disabled && !value) {
      this.control.enable();
    }
  }

  private setDefaultValue(value: unknown) {
    if (!this.control || this.control.value) {
      return;
    }

    this.control.setValue(value);
  }
}
